import React from 'react';
import Modal from '../shared/Modal';
import Formsy from 'formsy-react';
import FormsySimpleInput from '../form/SimpleInput';

class SkipWeekModal extends React.Component {
  state = {
    reason: ''
  };

  render() {
    return (
      <Modal isOpen={this.props.isOpen} onRequestClose={this.props.closeModal}>
        <Formsy onValidSubmit={this.handleSubmit}>
          <h2 className="h2 modal__heading">Skip Week</h2>
          <div className="form__row">
            <p className="p">Are you sure you want to skip this week?</p>
          </div>
          <div className="form__row form__row--spacer">
            <div className="form__row-item form__row-item--full">
              <p className="simple-input__label">Reason for Skipping</p>
              <FormsySimpleInput
                type="text"
                name="reason"
                value={this.state.reason}
                onChange={this.handleChange}
              />
            </div>
          </div>

          <div className="form__row">
            <div className="form__row-item form__row-item--half">
              <div
                className="btn btn--hollow-blue btn--full-width"
                onClick={this.props.closeModal}
              >
                Nevermind
              </div>
            </div>
            <div className="form__row-item form__row-item--half">
              <button
                type="submit"
                className="btn btn--hollow-red-bright btn--full-width"
              >
                Skip Week
              </button>
            </div>
          </div>
        </Formsy>
      </Modal>
    );
  }

  handleSubmit = () => {
    this.props.skipWeek(this.state.reason);
  };

  handleChange = e => this.setState({ [e.target.name]: e.target.value });
}
export default SkipWeekModal;



// WEBPACK FOOTER //
// ./src/components/menuSelection/SkipWeekModal.js